import SidePanel from '../SidePanel.jsx';
import ClientEditForm from './ClientEditForm.jsx';
import { useEffect, useState } from 'react';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';

const NewClient = ({ isOpen, onClose, refetch }) => {
    const [newClientData, setNewClientData] = useState({});

    const { save, isSaving } = useBusinessPostApi(`/clients/0`);

    useEffect(() => {
        if (isOpen) {
            // Start from a clean slate
            setNewClientData({});
        }
    }, [isOpen]);

    function doSave() {
        save(newClientData).then(() => {
            onClose();
            refetch();
        });
    }

    return (
        <SidePanel
            isOpen={isOpen}
            onClose={onClose}
            showSave={true}
            onSave={doSave}
            onCancel={onClose}
            title="New Client"
            saveLabel={isSaving ? 'Saving...' : 'Save'}
        >
            <ClientEditForm
                newClientData={newClientData}
                setNewClientData={setNewClientData}
            />
        </SidePanel>
    );
};

export default NewClient;
